type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const ReportStatus = Object.freeze({
  WAITING: 1 as const,
  COMPLETED: 2 as const,
});

export type ReportStatus = EnumLiteralsOf<typeof ReportStatus>;
